import axios from "axios";
import { getApiProxyBaseUrl } from "../runtimeConfig";

const TOKEN_KEY = "mgdr_jwt_token";

const API_PROXY_BASE = getApiProxyBaseUrl();

const api = axios.create({
    baseURL: `${API_PROXY_BASE}/api`,
    headers: { "Content-Type": "application/json" },
});

// Sin prefijo /api — usado por endpoints como /api/visualizador/*, /api/consumos/*
const apiBase = axios.create({
    baseURL: API_PROXY_BASE,
    headers: { "Content-Type": "application/json" },
});

const addAuthHeader = (config) => {
    const token = sessionStorage.getItem(TOKEN_KEY);
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
};

api.interceptors.request.use(addAuthHeader, (error) => Promise.reject(error));
apiBase.interceptors.request.use(addAuthHeader, (error) => Promise.reject(error));

let redirectingToLogin = false;

const onResponseError = (error) => {
    if (error.response?.status === 401 && !redirectingToLogin) {
        redirectingToLogin = true;
        sessionStorage.removeItem(TOKEN_KEY);
        window.location.replace("/login");
        setTimeout(() => { redirectingToLogin = false; }, 3000);
    } else if (error.response?.status >= 500) {
    }
    return Promise.reject(error);
};

api.interceptors.response.use((r) => r, onResponseError);
apiBase.interceptors.response.use((r) => r, onResponseError);

export { apiBase };
export default api;
